import buildSpotsList from './spots-list';

export default function activateGoogleSearchApi(map, spotsData, allMarkers, updateLongLat, lngLat) {
  const markerIconSearch = '/dist/images/icons/maps-marker-search.png';
  const searchElement = document.querySelector('[data-child-module="Locator__Search"]');
  const searchBox = new google.maps.places.SearchBox(searchElement);
  let timer;
  let markers = [];

  const boundsChanged = () => {
    map.addListener('bounds_changed', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        for (let i = 0; i < allMarkers.length; i += 1) {
          const element = document.querySelector(`[data-list-marker-id="${allMarkers[i].id}"]`);
          const noSpotMessageContainer = document.querySelector(
            '[data-child-module="Locator__NoSpots"]'
          );

          if (map.getBounds().contains(allMarkers[i].getPosition()) && element) {
            element.parentNode.removeAttribute('style');
            noSpotMessageContainer.style.display = 'none';
          } else if (element) {
            // element.parentNode.style.display = 'none';

            if (noSpotMessageContainer) {
              const visibleSpots = [];
              const allSpots = document.querySelectorAll('.js-locationlist-item');
              allSpots.forEach(spotItem => {
                const isVisible = spotItem.style.display === 'none';
                if (!isVisible) {
                  visibleSpots.push(element);
                }
              });
              if (visibleSpots.length === 0) {
                noSpotMessageContainer.removeAttribute('style');
              }
            }
          }
        }
      }, 200);
    });
  };

  searchBox.addListener('places_changed', () => {
    const places = searchBox.getPlaces();
    const bounds = new google.maps.LatLngBounds();
    const uniqueMarkerId = 1;

    if (places.length === 0) {
      return;
    }

    // Clear out the old markers
    markers.forEach(marker => {
      marker.setMap(null);
    });
    markers = [];

    const icon = {
      url: markerIconSearch,
      size: new google.maps.Size(71, 71),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 34),
      scaledSize: new google.maps.Size(25, 25)
    };

    const setNewStartToCalculateDistance = (placeLat, placeLng) => {
      updateLongLat(placeLng, placeLat);

      for (let i = 0; i < markers.length; i += 1) {
        if (markers[i].id === 1) {
          markers[i].setMap(null);

          markers.splice(i, 1);
        }
      }

      markers.push(
        new google.maps.Marker({
          map,
          icon,
          position: new google.maps.LatLng(placeLat, placeLng),
          id: uniqueMarkerId
        })
      );
    };

    let searchedPlaceLatitude = null;
    let searchedPlaceLongitude = null;
    places.forEach(place => {
      if (!place.geometry || !place.geometry.location) {
        return;
      }

      //
      markers.push(
        new google.maps.Marker({
          map,
          icon,
          title: place.name,
          position: place.geometry.location,
          id: uniqueMarkerId
        })
      );

      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }

      // Which marker is closest to search text result
      const distances = [];
      let closest = -1;
      for (let i = 0; i < allMarkers.length; i += 1) {
        const d = google.maps.geometry.spherical.computeDistanceBetween(
          allMarkers[i].position,
          place.geometry.location
        );
        distances[i] = d;
        if (closest === -1 || d < distances[closest]) {
          closest = i;
        }
      }

      map.fitBounds(places[0].geometry.viewport);
      map.setZoom(11);

      searchedPlaceLatitude = place.geometry.location.lat();
      searchedPlaceLongitude = place.geometry.location.lng();
      lngLat.destinationLat = searchedPlaceLatitude;
      lngLat.destinationLng = searchedPlaceLongitude;
      setNewStartToCalculateDistance(searchedPlaceLatitude, searchedPlaceLongitude);
    });

    buildSpotsList(spotsData, true, true, allMarkers, lngLat.destinationLat, lngLat.destinationLng);

    setTimeout(() => {
      const locationCategories = document.querySelectorAll('[data-module="Locator__Category"]');
      locationCategories.forEach(locationCategory => {
        const filterId = document.querySelector(`#${locationCategory.getAttribute('id')}`);
        if (filterId != null) {
          filterId.checked = false;
        }
      });

      allMarkers.forEach(marker => {
        marker.setVisible(true);
      });
    }, 1000);
  });

  boundsChanged();
}
